<afoone-breadcrumb
  [breadcrumbItems]="[
    {
      label: 'WEB_RESULTS.NAVIGATION.SEARCH_BY_PATIENT',
      route: '/patient-requests/',
      params: {
        searchType: 'search-by-patient'
      }
    },
    {
      label: 'WEB_RESULTS.NAVIGATION.SEARCH_BY_PATIENT_RESULTS',
    }
  ]"
></afoone-breadcrumb>

<p-table
  [value]="records"
  styleClass="p-datatable-striped"
  sortMode="single"
  dataKey="id"
  selectionMode="single"
  [sortField]="sortField"
  [sortOrder]="sortOrder"
  (onRowSelect)="onRowSelect($event)"
  [paginator]="true"
  [rows]="10"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} {{
    'LIST.OF' | translate
  }} {totalRecords} {{ 'LIST.RECORDS' | translate }}"
  [rowsPerPageOptions]="[10, 20, 30, 60, 80, 100]"
>
  <ng-template pTemplate="header">
    <tr>
      <ng-container *ngFor="let column of columns">
        <ng-container [ngSwitch]="column">
          <th pSortableColumn="historia" *ngSwitchCase="'historia'">
            {{ "PATIENT_DATA.HISTORIA" | translate }}
            <p-sortIcon field="historia"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="historia"
              matchMode="contains"
              display="menu"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th pSortableColumn="versNr" *ngSwitchCase="'versnr'">
            {{ "PATIENT_DATA.VERS_NR" | translate
            }}<p-sortIcon field="versNr"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="versNr"
              display="menu"
              matchMode="contains"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th pSortableColumn="notFallNr" *ngSwitchCase="'notfallnr'">
            {{ "PATIENT_DATA.NOT_FALL_NR" | translate
            }}<p-sortIcon field="notFallNr"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="notFallNr"
              display="menu"
              matchMode="contains"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th pSortableColumn="apellidos" *ngSwitchCase="'apellidos'">
            {{ "PATIENT_DATA.APELLIDOS" | translate }}
            <p-sortIcon field="apellidos"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="apellidos"
              matchMode="contains"
              display="menu"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th pSortableColumn="nombre" *ngSwitchCase="'nombre'">
            {{ "PATIENT_DATA.NOMBRE" | translate }}
            <p-sortIcon field="nombre"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="nombre"
              matchMode="contains"
              display="menu"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th pSortableColumn="fechaNac" *ngSwitchCase="'fechanac'">
            {{ "PATIENT_DATA.FECHANAC" | translate }}
            <p-sortIcon field="fechaNac"></p-sortIcon>
            <p-columnFilter
              type="date"
              field="fechaNac"
              display="menu"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th pSortableColumn="edad" *ngSwitchCase="'edad'">
            {{ "PATIENT_DATA.EDAD" | translate }}
            <p-sortIcon field="edad"></p-sortIcon>
            <p-columnFilter
              type="numeric"
              field="edad"
              display="menu"
              matchMode="equals"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
          <th pSortableColumn="sexo" *ngSwitchCase="'sexo'">
            {{ "PATIENT_DATA.SEXO" | translate }}
            <p-sortIcon field="sexo"></p-sortIcon>
            <p-columnFilter
              type="text"
              field="sexo"
              display="menu"
              matchMode="contains"
              [showOperator]="false"
              [showAddButton]="false"
            ></p-columnFilter>
          </th>
        </ng-container>
      </ng-container>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-record>
    <tr [pSelectableRow]="record">
      <ng-container *ngFor="let column of columns">
        <ng-container [ngSwitch]="column">
          <td *ngSwitchCase="'historia'">{{ record.historia }}</td>
          <td *ngSwitchCase="'versnr'">{{ record.versNr }}</td>
          <td *ngSwitchCase="'notfallnr'">{{ record.notFallNr }}</td>
          <td *ngSwitchCase="'apellidos'">{{ record.apellidos }}</td>
          <td *ngSwitchCase="'nombre'">{{ record.nombre }}</td>
          <td *ngSwitchCase="'fechanac'">
            {{ record.fechaNac | date: 'dd/MM/yyyy' }}
          </td>
          <td *ngSwitchCase="'edad'">{{ record.edad }}</td>
          <td *ngSwitchCase="'sexo'">{{ record.sexo }}</td>
        </ng-container>
      </ng-container>
    </tr>
  </ng-template>
</p-table>
